import {
  TestingWebhook,
  Webhook,
  WebhookStatus,
} from './features/Configuration/components/Webhook/types';
import { IncludeExclude } from './features/Monitor/components/AddMonitor/fixtures';
import {
  ConfigurationCTAUrlResponse,
  ConfigurationEmailResponse,
  MonitorDetails,
} from './features/Monitor/types';

export type Maybe<T> = T | undefined;
export type Nullable<T> = T | null;

export type ConfirmationModalAtom = {
  isOpen: boolean;
  title?: string;
  body?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export type OutreachEventLocationsModalAtom = {
  isOpen: boolean;
  title?: string;
  id?: string;
  locationsAmount?: number;
};

export type WebhookModalAtom = {
  isOpen: boolean;
  type: 'add' | 'edit';
  testWebhook: (webhook: TestingWebhook) => Promise<WebhookStatus | undefined>;
  webhook: Webhook;
  refetchWebhooks: () => void;
};

export type UrlModalAtom = {
  isOpen: boolean;
  type: 'add' | 'edit';
  url: ConfigurationCTAUrlResponse;
  refetchUrls: () => void;
};

export type EmailModalAtom = {
  isOpen: boolean;
  type: 'add' | 'edit';
  email: ConfigurationEmailResponse;
  refetchEmails: () => void;
};

export type ConfigurationInfoModalAtom = {
  isOpen: boolean;
  type: 'lastError' | 'outreachList';
  data: Maybe<ConfigurationInfoModalData>;
  monitorType?: 'autonomous' | 'user';
};

export type ConfigurationInfoModalData = {
  outreachId?: string;
  lastError?: string;
  errorMessage?: string;
  lastErrorMessage?: string;
  monitorDetails?: MonitorDetails;
};

export type CsvFilePostResponse = {
  fileId?: string; // Note: List API returns file_idd not fileId
  name: string;
  size: number;
  createdAt: string;
  updatedAt: string;
  locationIdsList?: string[];
  partnerId: string;
};

export type CsvFileSummary = {
  file_id?: string; // Note: POST API returns fileId not file_id
  name: string;
  size: number;
  updatedAt: string;
  criteriaType?: IncludeExclude;
};

export type User = {
  role?: Role;
  partnerIds: Partner[];
  name: string;
  email: string;
};

export enum Role {
  PlumeAdmin = 'plumeAdmin',
  PartnerAdmin = 'partnerAdmin',
  PlumeAdminReadOnly = 'plumeAdminReadOnly',
  PartnerSupportManagerInternal = 'partnerSupportManagerInternal',
  PartnerSupportManagerExternal = 'partnerSupportManagerExternal',
  PartnerSupportEngineer = 'partnerSupportEngineer',
}

export type Partner = {
  name: string;
  id?: string;
  primaryDeployment?: string;
};

export type Deployment = {
  name: string;
};

export type Fixture<T> = (override?: Partial<T>, ...args: any[]) => T;

export type CreatedUpdated = {
  createdAt: string;
  updatedAt: string;
};

export type MonitorCriteriaNameMap = Record<string, string>;

export interface ErrorResponse {
  message: string;
}
